import KformComponent from '../kform-component';
import Card from '~/scripts/services/model/card';

export default class TextfieldComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentTextfield | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.autofocus = settings?.autofocus ?? false;
		this.conditional = settings?.conditional ?? {
			eq:   '',
			show: undefined,
			when: undefined,
		};
		this.defaultValue = settings?.defaultValue ?? '';
		this.disabled = settings?.disabled ?? false;
		this.event = {
			onChange: undefined,
			...settings?.event,
		};
		this.input = true;
		this.inputMask = settings?.inputMask ?? '';
		this.inputType = settings?.inputType ?? 'text';
		this.kdata = {
			submit: true,
			...settings?.kdata,
		};
		this.persistent = settings?.persistent ?? true;
		this.placeholder = settings?.placeholder ?? '';
		this.prefix = settings?.prefix ?? '';
		this.protected = settings?.protected ?? false;
		this.spellcheck = settings?.spellcheck ?? true;
		this.suffix = settings?.suffix ?? '';
		this.validate = {
			card:          new Card(settings?.validate?.card ?? '0-1'),
			custom:        settings?.validate?.custom ?? '',
			customMessage: settings?.validate?.customMessage,
			maxLength:     settings?.validate?.maxLength ?? null,
			minLength:     settings?.validate?.minLength ?? null,
			pattern:       settings?.validate?.pattern ?? '',
		};
	}

	/**
	 * @returns {Set<string>}
	 */
	getSubmissionKeys() {
		return new Set([
			'name',
		]);
	}
}
